import $ from "jquery";
import debounce from "lodash/debounce";

$(document).on("ready", function () {
  // escape hatch
  if (!$(".event-sidebar").length) return;

  // Fix VH on mobile with CSS variable
  function mobileCssVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
  mobileCssVh();
  window.addEventListener("resize", debounce(mobileCssVh, 100));

  // Sidebar toggle for mobile
  $(".js-event-nav-toggle, .js-event-sidebar-close").on("click", function () {
    $(".event-sidebar").toggleClass("open");
    $("body").toggleClass("sidebar-open");
  });

  // "lazy load" sidebar tabs
  let sidebarFrames = document.querySelectorAll(
    ".event-sidebar-tab-content iframe[data-src]"
  );
  sidebarFrames.forEach((frame) => {
    const uri = frame.dataset.src;
    frame.src = uri;
  });
});
